/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/importable_external_bank_account';
import '../../models/external_bank_account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ImportExternalBankAccountRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "importableAccount": {
                        "type": ".squareup.sfs.external.models.ImportableExternalBankAccount",
                        "id": 2,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ImportExternalBankAccountResponse": {
                    "fields": {
                      "externalBankAccount": {
                        "type": ".squareup.sfs.external.models.ExternalBankAccount",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ImportExternalBankAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ImportExternalBankAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ImportExternalBankAccountRequest @ squareup/sfs/external/services/external_bank_account/import_external_bank_account.proto at 10:1
 */
export const ImportExternalBankAccountRequest = $root.lookupType('squareup.sfs.external.service.ImportExternalBankAccountRequest');
fixType(ImportExternalBankAccountRequest, {
  idempotencyKey: {
    required: true
  },
  importableAccount: {
    required: true
  },
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(ImportExternalBankAccountRequest);
/**
 * SOURCE ImportExternalBankAccountResponse @ squareup/sfs/external/services/external_bank_account/import_external_bank_account.proto at 27:1
 */
export const ImportExternalBankAccountResponse = $root.lookupType('squareup.sfs.external.service.ImportExternalBankAccountResponse');
fixType(ImportExternalBankAccountResponse);
Builder.createAndAttachToType(ImportExternalBankAccountResponse);